export default __webpack_public_path__ + "fonts/optimer_bold.typeface.json";